<app-larged-tuile
  icon="fa-kit fa-picto-constance"
  [title]="'dashboard.water_level' | translate"
  [buttons]="buttons"
  [mode]="this.actionStack!.getValue('coSMesureBatterieCapteur') + '%'"
  [modeColor]="
    this.actionStack!.getValue('coSMesureBatterieCapteur') >= 50
      ? 'color-green'
      : this.actionStack!.getValue('coSMesureBatterieCapteur') >= 15
        ? 'color-orange'
        : 'color-red'
  "
  [statusMode]="this.actionStack!.getValue('coSAlarm') === 1 ? 'alarm' : null"
  [selectItem]="this.actionStack!.getValue('coCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.Constance_Control,
      'coCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
